<template>
  <div
    class="asc-ag-tooltip pa-4"
    :style="{
      backgroundColor: backgroundColor,
      color: color,
      width: width,
    }"
  >
    <!-- eslint-disable-next-line vue/no-v-html-->
    <div v-if="isHtmlContent" v-html="value"></div>
    <div v-else>{{ value }}</div>
  </div>
</template>
<script>
export default {
  name: 'AscAgTooltip',
  data: function () {
    return {
      backgroundColor: null,
      color: null,
      width: null,
      isHtmlContent: false,
    }
  },
  beforeMount() {
    this.value = this.params.value
    this.location = this.params.location
    this.backgroundColor = this.params.backgroundColor || '#fff'
    this.color = this.params.color || '#000'
    this.width = this.params.width || 'unset'
    this.isHtmlContent = this.params.isHtmlContent || false
  },
}
</script>
<style scoped lang="scss">
.asc-ag-tooltip {
  font-family: 'Roboto';
  font-size: '12px';
  line-height: '20px';
}
</style>
